module.exports = __webpack_public_path__ + "static/media/p4.88639a23.jpg";